import Layout from "../../layout/Portal";
import "./styles.scss";
import Button from "../../../components/Button";
import Icon from "../../../components/Icon";
import { useNavigate } from "react-router-dom";
import Toggle from "react-toggle";
import { useCallback, useEffect, useState } from "react";
import "react-toggle/style.css";
import { checkPayoutDate, currencyFormat } from "../../../utils/helpers";
import { toast } from "sonner";
import { usePayment } from "../../../context/PaymentContext";
import { API_URL } from "../../../utils/constants";
import { ClipLoader } from "react-spinners";
import { useQuery } from "@tanstack/react-query";
import { fetchBalance } from "../../../features/Dashboard";
import Modal, { getIcon } from "./withdraw.modal";
import { IPayoneer, IPayPal, PaymentMethod } from "../../profile/types";
import { getEmptyDetails } from "../../profile/walletSettings";

// interface PaymentMethod {
//   id: string;
//   type: string;
//   accountEnding: string;
//   details: {
//     isPrimary: boolean;
//     payoneerId: string;
//     email?: string;
//   };
// }

const intialPaymentId = {
  id: "",
  type: "",
  accountEnding: "",
  isPrimary: false,
  details: getEmptyDetails(""),
};

export const Withdraw = () => {
  const navigate = useNavigate();
  const [values, updateValues] = useState({
    data: "50",
    loading: false,
    error: "",
  });

  const [valuesPayID, updateValuesPayID] = useState<{
    data: PaymentMethod[];
    loading: boolean;
    error: string;
  }>({
    data: [],
    loading: false,
    error: "",
  });

  const [toggle, setToggle] = useState(false);
  const [amount, setAmount] = useState("");

  const [selectedPayId, setSelectedPayId] =
    useState<PaymentMethod>(intialPaymentId);

  const [showDrop, setShowDrop] = useState(false);
  const { paymentData, setPaymentData } = usePayment();

  const _submitHandler = () => {
    if (parseInt(amount) < 60 || !amount) {
      toast.warning("Minimum withdrawal amount is 60 USD", {
        richColors: true,
      });
    } else if (parseInt(amount) > parseInt(balanceData)) {
      //balanceData
      toast.warning(
        "You cannot initiate a withdrawal more than your current balance!",
        {
          richColors: true,
        }
      );
    } else if (
      !(selectedPayId.details as IPayoneer).payoneerId &&
      !(selectedPayId.details as IPayPal).email
    ) {
      toast.warning("Select or add a payment ID!", {
        richColors: true,
      });
    } else {
      const calcTotal = () => {
        const parsedAmount = parseInt(amount);
        if (isNaN(parsedAmount)) return 0;

        const emergencyCharge = parsedAmount * 0.05;
        const normalCharge = parsedAmount * 0.08;

        return toggle
          ? parsedAmount - normalCharge - emergencyCharge
          : parsedAmount - normalCharge;
      };

      setPaymentData({
        ...paymentData,
        account:
          selectedPayId.type === "paypal"
            ? ((selectedPayId.details as IPayPal).email as string)
            : (selectedPayId.details as IPayoneer).payoneerId,
        amount: parseInt(amount),
        youReceive: calcTotal(),
        emergency: toggle,
        fee: parseInt(amount) - 5,
        emergencyCharge: parseInt(amount) * 0.05,
        id: selectedPayId.id,
      });
      navigate("./summary");
    }
  };

  const fetchPayId = useCallback(async () => {
    const token = await localStorage.getItem("token");

    updateValuesPayID({ ...valuesPayID, loading: true, error: "" });
    const url = `${API_URL}/payment-method`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result && result.length > 0) {
        updateValuesPayID({
          ...valuesPayID,
          data: result,
          loading: false,
        });

        const defaultPayId = result.find(
          (item: PaymentMethod) => item.isPrimary || false || true || ""
        );
        if (
          (defaultPayId?.details as IPayoneer)?.payoneerId ||
          (defaultPayId.details as IPayPal)?.email
        ) {
          setSelectedPayId(defaultPayId || "");
        }
      } else if (result.length === 0) {
        updateValuesPayID({
          ...valuesPayID,
          data: result,
          loading: false,
        });
        setSelectedPayId(intialPaymentId);
      } else {
        updateValuesPayID({
          ...valuesPayID,
          loading: false,
          error: result.message ?? "Something went wrong",
        });
      }
    } catch (err: any) {
      // console.log(err);
      updateValuesPayID({
        ...valuesPayID,
        loading: false,
        error: err.message ?? "Something went wrong",
      });
    }
  }, []);

  const {
    data: balanceData,
    isLoading: isBalanceLoading,
    error: balanceError,
  } = useQuery({
    queryKey: ["balance"],
    queryFn: fetchBalance,
  });

  useEffect(() => {
    fetchPayId();
  }, [fetchBalance, fetchPayId]);

  return (
    <Layout>
      <Button
        onClick={() => navigate(-1)}
        variant="neutral"
        className="go-back"
      >
        <Icon name="left_arrow" />
        <p className="back">Back</p>
      </Button>
      {isBalanceLoading || valuesPayID.loading ? (
        <div>
          <ClipLoader />
          <p>Loading</p>
        </div>
      ) : values.error || valuesPayID.error ? (
        <p>Something went wrong, reload</p>
      ) : (
        <div className="withdraw-content-container">
          <h3 className="w-title">Withdraw Your Earnings</h3>

          {toggle ? (
            <div>
              <p className="w-notice">Emergency Withdrawal Fee Notice!</p>
              <p className="w-notice-subtitle">
                Choosing an emergency withdrawal will include an additional fee
                of 5% of withdrawal amount, this is to ensure faster processing
                to meet your urgent needs.
              </p>
            </div>
          ) : (
            <div>
              <p className="w-message">
                {`Your Withdrawal will be processed ${checkPayoutDate()}
        Requests made within 48 hours before 14th and 28th, will be processed
        on the next payout day, except in cases of emergencies, which are
        processed within 48 hours. You will be notified once your
        withdrawal is completed. For any delays or inquiries, please
        contact our support team.`}
              </p>
            </div>
          )}

          <p className="w-balance">Wallet Balance</p>
          <p className="w-amount">
            {!balanceError
              ? currencyFormat(parseInt(balanceData))
              : "Balance Unavailable"}
          </p>

          <label className="w-label">Enter withdrawal amount (USD)</label>
          <br />
          <input
            value={amount}
            defaultValue={amount}
            onChange={(e) => {
              const replacedText = e.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/^0(?!\.)/, "")
                .replace(/(\.\d{2})\d+/, "$1")
                .replace(/^([1-9]\d*(\.\d{0,2})?).*$/, "$1");

              setAmount(replacedText);
            }}
            className="w-input"
            placeholder="E.g. 60"
            type="number"
          />

          <p className="w-account">Withdrawal account</p>
          <div className={`payment-card selected`}>
            {getIcon(selectedPayId.type as string)}
            <div className="card-details">
              <h3 className="card-title">{selectedPayId.type}</h3>
              <p className="card-info">
                {selectedPayId.type === "payoneer"
                  ? (selectedPayId.details as IPayoneer)?.payoneerId
                  : selectedPayId.type === "paypal"
                  ? (selectedPayId.details as IPayPal)?.email
                  : "Not Provider"}
              </p>
            </div>
          </div>
          <div className="w-user-account">
            <p
              onClick={() => setShowDrop(!showDrop)}
              className="w-change-account"
            >
              {showDrop ? "Close" : "Change"}
            </p>

            <Modal
              isOpen={showDrop}
              onClose={() => setShowDrop(false)}
              options={valuesPayID.data}
              selectedId={selectedPayId}
              onSelect={(item: PaymentMethod) => {
                setSelectedPayId(item);
                setShowDrop(false);
              }}
            />
          </div>

          <div className="w-emergency-container">
            <div>
              <p className="w-emergency">Emergency Withdrawal</p>
              <p className="w-48hrs">Process within 48hrs</p>
            </div>
            <label>
              <Toggle
                defaultChecked={toggle}
                icons={false}
                onChange={() => setToggle(!toggle)}
              />
            </label>
          </div>

          <div className="w-proceed-container">
            <button
              disabled={values.loading || !values.data}
              onClick={() => _submitHandler()}
              className="w-proceed"
            >
              Proceed
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
};
